import { Component, OnInit } from '@angular/core';
import {NgForm} from '@angular/forms';
import {Observable} from 'rxjs';
import {Router, ActivatedRoute} from '@angular/router';
import * as firebase from "firebase/app";

// Add the Firebase services that you want to use
import "firebase/auth";
import "firebase/database";


@Component({
  selector: 'app-addwrittencontact',
  templateUrl: './addwrittencontact.component.html',
  styleUrls: ['./addwrittencontact.component.css']
})
export class AddwrittencontactComponent implements OnInit {

pictureurl:any;
description:any;
name:any;
where:any;
  constructor(private route:ActivatedRoute) { }

  ngOnInit() {
    this.where = this.route.snapshot.paramMap.get('where');
  }
save(faculty:NgForm){
  let value = faculty.value;
  let descript = document.getElementById('display').innerHTML;
  let pictureurlsi = document.getElementById('pictureurl').innerHTML;
  console.log(pictureurlsi);
    let pictureurls = JSON.parse(pictureurlsi);
    let pictureurl = pictureurls.image;

  let desc = {desc:descript, pictureurl: pictureurl};
  let p ={...desc, ...faculty.value}
  console.log(p);
  let id = p.name;
  let db= firebase.database();
  db.ref(this.where+'/'+id).set({pictureurl: p.pictureurl,
  description: p.desc, name:id}, function(error){
    if(error){
      alert(error)
    }else{alert('data saved successfully')}
  })
}
}
